export const GTAG_PROPERTIES_KEY = 'gtag_properties';
export const SIGNUP_SEGMENT_PROPERTIES_KEY = "signup_segment_properties"



// WEBPACK FOOTER //
// ./src/js/constants.js